// 조명: 하늘·땅 반구광, 그림자 드리우는 주광(카메라 대상을 따라감), 뒤쪽 역광.
// 세기는 r128 값 × π. three 0.155부터 물리 기반 세기라서 같은 밝기를 내려면 π를 곱해야 한다.
import * as THREE from 'three';
import { ENGINE } from './renderer';

/** r128 세기 → 0.169 세기 배율 (모든 조명 공통, 점광원 감쇠는 renderer.ts에서 r128 방식으로 바꿨다). */
export const LEGACY = Math.PI;

export interface Lights {
  hemi: THREE.HemisphereLight;
  key: THREE.DirectionalLight;
  rim: THREE.DirectionalLight;
  /** 주광과 그림자 범위를 (x, z) 주변으로 옮긴다. */
  follow(x: number, z: number): void;
}

export function createLights(scene: THREE.Scene): Lights {
  const hemi = new THREE.HemisphereLight(0xEAF2FA, 0xA8B4BE, 0.55 * LEGACY);
  scene.add(hemi);

  const key = new THREE.DirectionalLight(0xFFF1DE, 0.58 * LEGACY);
  key.position.set(6, 12, 8);
  key.castShadow = true;
  key.shadow.mapSize.set(ENGINE.shadowMapSize, ENGINE.shadowMapSize);
  const sc = key.shadow.camera;
  sc.left = -14; sc.right = 14; sc.top = 14; sc.bottom = -14; sc.far = 40;
  key.shadow.bias = -0.0008;
  key.shadow.normalBias = 0.03;
  key.shadow.radius = 3;
  scene.add(key, key.target);

  const rim = new THREE.DirectionalLight(0xFFFFFF, 0.3 * LEGACY);
  rim.position.set(-3, 4, -5);
  scene.add(rim);

  return {
    hemi, key, rim,
    follow(x, z) {
      key.position.set(x + 6, 12, z + 8);
      key.target.position.set(x, 0, z);
    },
  };
}

